export default "__VITE_ASSET__DsC0pfM8__"